module.exports = __webpack_public_path__ + "static/media/instagram-stories-skater.db2af4a2.mp4";